(function () {
  function buildSrcset(imageUrlBase, widths) {
    return widths
      .map(function (w) {
        return imageUrlBase.replace(/width=\d+/, 'width=' + w) + ' ' + w + 'w';
      })
      .join(', ');
  }

  function setHeroImage(img, src, srcset, width, height, alt) {
    if (!img) return;
    img.src = src;
    if (srcset) img.srcset = srcset;
    if (width) img.width = width;
    if (height) img.height = height;
    if (alt) img.alt = alt;
  }

  function getHeroState(source) {
    return {
      heroDesktop: source.dataset.heroDesktop || '',
      heroSrcsetDesktop: source.dataset.heroSrcsetDesktop || '',
      heroWidthDesktop: source.dataset.heroWidthDesktop || '',
      heroHeightDesktop: source.dataset.heroHeightDesktop || '',
      heroMobile: source.dataset.heroMobile || '',
      heroSrcsetMobile: source.dataset.heroSrcsetMobile || '',
      heroWidthMobile: source.dataset.heroWidthMobile || '',
      heroHeightMobile: source.dataset.heroHeightMobile || '',
      heroAlt: source.dataset.heroAlt || '',
      heroLink: source.dataset.heroLink || '',
      thumbSrc: source.dataset.thumbSrc || source.dataset.heroDesktop || '',
      thumbSrcset: source.dataset.thumbSrcset || '',
      thumbAlt: source.dataset.thumbAlt || source.dataset.heroAlt || ''
    };
  }

  function setHeroState(target, state) {
    if (!target || !state) return;
    target.dataset.heroDesktop = state.heroDesktop || '';
    target.dataset.heroSrcsetDesktop = state.heroSrcsetDesktop || '';
    target.dataset.heroWidthDesktop = state.heroWidthDesktop || '';
    target.dataset.heroHeightDesktop = state.heroHeightDesktop || '';
    target.dataset.heroMobile = state.heroMobile || '';
    target.dataset.heroSrcsetMobile = state.heroSrcsetMobile || '';
    target.dataset.heroWidthMobile = state.heroWidthMobile || '';
    target.dataset.heroHeightMobile = state.heroHeightMobile || '';
    target.dataset.heroAlt = state.heroAlt || '';
    target.dataset.heroLink = state.heroLink || '';
    target.dataset.thumbSrc = state.thumbSrc || '';
    target.dataset.thumbSrcset = state.thumbSrcset || '';
    target.dataset.thumbAlt = state.thumbAlt || '';
  }

  function setThumbImage(thumb, state) {
    var img = thumb ? thumb.querySelector('img') : null;
    if (!img || !state) return;

    if (state.thumbSrc) img.src = state.thumbSrc;
    if (state.thumbSrcset) img.srcset = state.thumbSrcset;
    if (state.thumbAlt) {
      img.alt = state.thumbAlt;
      thumb.setAttribute('aria-label', state.thumbAlt);
    }
  }

  function setHeroLink(link, href, label) {
    if (!link) return;

    if (href) {
      link.href = href;
      link.hidden = false;
      link.removeAttribute('aria-hidden');
      if (label) link.setAttribute('aria-label', label);
      return;
    }

    link.removeAttribute('href');
    link.hidden = true;
    link.setAttribute('aria-hidden', 'true');
  }

  function initGallery(root) {
    if (!root || root.dataset.osGalleryInit === 'true') return;
    root.dataset.osGalleryInit = 'true';

    var heroDesktop = root.querySelector('[data-os-gallery-hero-desktop]');
    var heroMobile = root.querySelector('[data-os-gallery-hero-mobile]');
    var heroLinks = root.querySelectorAll('[data-os-gallery-link]');
    var thumbs = root.querySelectorAll('[data-os-gallery-thumb]');

    if (!thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var currentHero = getHeroState(root);
        var nextHero = getHeroState(thumb);

        setHeroImage(
          heroDesktop,
          nextHero.heroDesktop,
          nextHero.heroSrcsetDesktop,
          nextHero.heroWidthDesktop,
          nextHero.heroHeightDesktop,
          nextHero.heroAlt
        );

        setHeroImage(
          heroMobile,
          nextHero.heroMobile,
          nextHero.heroSrcsetMobile,
          nextHero.heroWidthMobile,
          nextHero.heroHeightMobile,
          nextHero.heroAlt
        );

        heroLinks.forEach(function (link) {
          setHeroLink(link, nextHero.heroLink, nextHero.heroAlt);
        });

        setHeroState(root, nextHero);
        setHeroState(thumb, currentHero);
        setThumbImage(thumb, currentHero);
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-os-banner-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (!section) return;
    var gallery = section.querySelector('[data-os-banner-gallery]');
    if (gallery) {
      gallery.dataset.osGalleryInit = 'false';
      initGallery(gallery);
    }
  });
})();
